/* Cart page: keeps the optional "Job Name" cart attribute saved while the customer types, so it reaches the order
   even when checkout starts without posting the cart form (Pickeasy's checkout handling, express buttons).
   Only this one attribute is sent; Shopify merges it with the others (Pickeasy's Order Location and so on). */
(() => {
  const input = document.querySelector('[data-cart-job-name]');
  if (!input) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let saved = input.value.trim();
  let timer = null;

  const save = () => {
    clearTimeout(timer);
    const value = input.value.replace(/\s+/g, ' ').trim().slice(0, 100);
    if (value === saved) return Promise.resolve();
    saved = value;
    return fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Job Name': value } }),
      keepalive: true,
    }).catch(() => { saved = null; });
  };

  input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(save, 800); });
  input.addEventListener('change', save);
  input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); save(); } });
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('[name="checkout"], .additional-checkout-buttons')) save();
  }, true);
})();
